import React, { useEffect, useRef, useState } from "react";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import axios from "axios";

/**
 * AuthCallback, processa o session_id retornado pelo Emergent Google Auth
 * e redireciona para o app externo (app.cemedeiros.com.br).
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH.
 */
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const [state, setState] = useState({ status: "loading", message: "Validando sessão…" });
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;

    if (!sessionId) {
      setState({ status: "error", message: "Sessão não encontrada na URL." });
      return;
    }

    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/google/process`, {
          session_id: sessionId,
        });
        setState({
          status: "ok",
          message: `Bem-vindo, ${data?.user?.name || "amigo"}! Redirecionando…`,
        });
        // Pequeno delay para o usuário ver o feedback
        setTimeout(() => {
          window.location.href = data.redirect_to;
        }, 1200);
      } catch (e) {
        const detail = e?.response?.data?.detail || "Falha ao validar sessão.";
        setState({ status: "error", message: detail });
      }
    })();
  }, []);

  return (
    <div
      data-testid="auth-callback-page"
      className="min-h-screen flex items-center justify-center bg-[#0B1E36] px-6"
    >
      <div className="max-w-md w-full bg-white p-10 text-center border border-white/10">
        {state.status === "loading" && (
          <>
            <Loader2 size={36} strokeWidth={1.5} className="mx-auto text-[#C5A059] animate-spin mb-4" />
            <h1 className="font-serif-display text-[1.6rem] text-[#0B1E36]">{state.message}</h1>
            <p className="text-[0.82rem] text-[#0B1E36]/55 mt-2">
              Estamos finalizando seu acesso com segurança.
            </p>
          </>
        )}
        {state.status === "ok" && (
          <>
            <CheckCircle2 size={36} strokeWidth={1.5} className="mx-auto text-emerald-600 mb-4" />
            <h1 data-testid="auth-callback-ok" className="font-serif-display text-[1.6rem] text-[#0B1E36]">
              {state.message}
            </h1>
            <p className="text-[0.82rem] text-[#0B1E36]/55 mt-2">
              Levando você para o App CMedeiros…
            </p>
          </>
        )}
        {state.status === "error" && (
          <>
            <XCircle size={36} strokeWidth={1.5} className="mx-auto text-rose-600 mb-4" />
            <h1 data-testid="auth-callback-error" className="font-serif-display text-[1.4rem] text-[#0B1E36]">
              Não foi possível concluir o acesso
            </h1>
            <p className="text-[0.88rem] text-[#0B1E36]/70 mt-2">{state.message}</p>
            <a
              href="/"
              className="inline-block mt-5 text-[0.7rem] uppercase tracking-[0.22em] text-[#C5A059] hover:text-[#0B1E36] border-b border-[#C5A059] pb-0.5"
            >
              Voltar para o início
            </a>
          </>
        )}
      </div>
    </div>
  );
}
